import React, { useEffect, useMemo, useState } from 'react';
import { ProjetoNaoPrevisto, getProjetosNaoPrevisto } from '@app/api/naoPrevistos/parametros';
import { compareText } from '@app/helpers/comparators';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';
import { Button, ColumnProps, Table, Widget } from '@digital/ui';
import { downloadRelatorioExcel } from '@app/components/GerarBlobExportacaoExcel';

interface Props {
    orcadoAnoNaoPrevistoId: string;
    reload: boolean;
}

const ProjetosTable = ({
    orcadoAnoNaoPrevistoId,
    reload
}: Props) => {
    const [projetos, setProjetos] = useState([])


    useEffect(() => {
        if (orcadoAnoNaoPrevistoId) {
            getProjetosNaoPrevisto(orcadoAnoNaoPrevistoId).then((data) => {
                setProjetos(data);
            })
        }
    }, [reload, orcadoAnoNaoPrevistoId])

    const columns = useMemo(() => {
        const columnsTemp: ColumnProps<ProjetoNaoPrevisto>[] = new Array();

        columnsTemp.push({
            title: 'Código',
            dataIndex: 'codigo',
            width: '10%',
            sorter: (a, b) => compareText(a.codigo, b.codigo),
            ...mountFormFilterDropDown('codigo', 'Pesquisar')
        });

        columnsTemp.push({
            title: 'Nome',
            dataIndex: 'nome',
            width: '30%',
            sorter: (a, b) => compareText(a.nome, b.nome),
            ...mountFormFilterDropDown('nome', 'Pesquisar')
        });

        columnsTemp.push({
            title: 'Classificação Contábil',
            dataIndex: 'classificacaoContabil',
            width: '10%',
            sorter: (a, b) => compareText(a.classificacaoContabil, b.classificacaoContabil),
            ...mountFormFilterDropDown('classificacaoContabil', 'Pesquisar')
        });


        columnsTemp.push({
            title: 'Diretoria',
            dataIndex: 'diretoria',
            width: '20%',
            sorter: (a, b) => compareText(a.diretoria, b.diretoria),
            ...mountFormFilterDropDown('diretoria', 'Pesquisar')
        });

        columnsTemp.push({
            title: 'Área',
            dataIndex: 'area',
            width: '20%',
            sorter: (a, b) => compareText(a.area, b.area),
            ...mountFormFilterDropDown('area', 'Pesquisar')
        });

        columnsTemp.push({
            title: 'Departamento',
            dataIndex: 'departamento',
            width: '20%',
            sorter: (a, b) => compareText(a.departamento, b.departamento),
            ...mountFormFilterDropDown('departamento', 'Pesquisar')
        });

        return columnsTemp;
    }, [])


    const saveFile = () => {
        const colunasNomes = columns.map((coluna) => {
            return coluna.title.props.id
        })

        console.log('colunasNomes', colunasNomes)
        console.log('projetos', projetos)

        var rows = projetos.map((projeto: ProjetoNaoPrevisto) => {
            return [
                projeto.codigo,
                projeto.nome,
                projeto.classificacaoContabil,
                projeto.diretoria,
                projeto.area,
                projeto.departamento,
            ]

        });

        console.log('rows', rows);

        downloadRelatorioExcel(rows, [30, 30, 30, 30, 30, 30,], 'Projetos', colunasNomes)
    }

    const btnExportacao = () => {
        return []
        return [<Button onClick={saveFile}> Exportar para XLSX </Button>]
    }

    return (
        <Widget
            actions={btnExportacao()}
            title="Projetos" id='widgetTabelaProjetos'>
            <Table
                dataSource={projetos}
                columns={columns}
                rowKey={'id'}
            />
        </Widget>
    );
};

export default ProjetosTable;
